import { RoutesMap } from '@Router/router.types';
import { CddEmbeddedFields } from '../../../../eddQuestions/pages/direct/field.types';
import { createUseCddLogic } from '../../../common/useCddLogic';
import type { CddDataFull, CddVolumeOptions } from '../../../common/api/cdd.api.types';
import type { CddVolumesFormValues } from '../../../common/formatCddDataToFormValues';

const formatCddDataToFormValues = (data: CddDataFull | undefined): CddVolumesFormValues => ({
  [CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_INCOMING]:
    data?.internationalWiresIncoming ?? '',
  [CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_OUTGOING]:
    data?.internationalWiresOutgoing ?? '',
});

export const useCddInternationalWiresLogic = createUseCddLogic({
  schemaTitle: 'CddInternationalWiresVolumes',
  route: RoutesMap.CDD_INTERNATIONAL_WIRES_VOLUMES,
  questionOneFieldName: CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_INCOMING,
  questionTwoFieldName: CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_OUTGOING,
  formatCddDataToFormValues,
  getPayload: (values) => ({
    internationalWiresIncoming: values[
      CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_INCOMING
    ] as CddVolumeOptions,
    internationalWiresOutgoing: values[
      CddEmbeddedFields.CDD_INTERNATIONAL_WIRES_VOLUMES_OUTGOING
    ] as CddVolumeOptions,
  }),
});
